import Dropdown from "../../../components/dropdown/Dropdown.jsx";
import Code from "../../../components/code/Code.jsx";

<div className="box_link"><a className="link  link_materials" target="_blank" href="https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2015/Arkusze_egzaminacyjne/2017/formula_od_2015/informatyka/MIN-R2_1P-172.pdf">LINK DO ARKUSZA</a>
<br/>
<a className="link  link_materials" href="http://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2015/Arkusze_egzaminacyjne/2017/formula_od_2015/informatyka/Dane_PR2.zip">PLIKI DO ZADANIA</a>
<br/>
</div>

### TREŚĆ
W pliku <i>dane.txt</i> znajduje się 200 wierszy. Każdy wiersz zawiera 320 liczb naturalnych
z przedziału od 0 do 255, oddzielonych znakami pojedynczego odstępu (spacjami).<br/>
Przedstawiają one jasności kolejnych pikseli czarno-białego obrazu o wymiarach 320 na 200
pikseli (od 0 – czarny do 255 – biały).<br/>
Napisz program(y), który(e) da(dzą) odpowiedzi do poniższych zadań. Odpowiedzi zapisz
w pliku <i>wyniki6.txt</i>, a każdą odpowiedź poprzedź numerem oznaczającym odpowiednie
zadanie.<br/><br/>
<span className="bold">Uwaga</span>: plik <i>przyklad.txt</i> zawiera dane przykładowe spełniające warunki zadania (obraz
ma takie same rozmiary). Odpowiedzi dla danych z pliku <i>przyklad.txt</i> są podane pod
poleceniami. 

<br/><br/>

### Zadanie 4 (0-4pkt.)
Podaj długość najdłuższej linii pionowej (czyli ciągu kolejnych pikseli w tej samej kolumnie
obrazka), złożonej z pikseli tej samej jasności.<br/><br/>
Dla danych z pliku <i>przyklad.txt</i> wynikiem jest 198. 

<br/><br/>

<Dropdown title="ODPOWIEDŹ">

```
5
```
</Dropdown>

<Dropdown title="PRZYKŁADOWE ROZWIĄZANIE - PYTHON">

```python
def rotate_matrix(matrix_old: list[list]) -> list[list]:
    new_matrix = [[]]

    for column_index in range(len(matrix_old[0])):
        for row_index in range(len(matrix_old)):
            new_matrix[-1].append(matrix_old[row_index][column_index])

        new_matrix.append([])

    return new_matrix[:-1]


def get_image() -> list[list[int]]:
    with open("dane.txt") as image:
        lines = image.read().strip().split("\n")

    matrix = [[int(pixel) for pixel in line.split(" ")] for line in lines]

    return matrix


def get_longest_repeating(row: list[int]) -> int:
    if not row:
        return 0

    current_count = 1
    max_count = 1

    for index in range(1, len(row)):

        if row[index - 1] != row[index]:
            max_count = max(max_count, current_count)
            current_count = 1
            continue

        current_count += 1

    max_count = max(max_count, current_count)

    return max_count


def main():
    image = get_image()

    image_rotated = rotate_matrix(image)

    get_longest_repeating(image_rotated[0])

    max_repeating = 0

    for column in image_rotated:
        max_repeating = max(max_repeating, get_longest_repeating(column))

    print(max_repeating)


if __name__ == "__main__":
    main()

```
</Dropdown>